<template>
    <tr>
        <td>#{{ invoice.id }}</td>
        <td>{{ invoice.issued_date }}</td>
        <td>{{ getCurrency }}{{ invoice.balance_due - invoice.paid_amount < 0 ? 0 : invoice.balance_due - invoice.paid_amount | formatNumber }}</td>
        <td>
            <div class="field paid-amount-field">
                <div class="used_amount_tooltip">The amount entered here is more than the amount paid by the customer.</div>
                <p class="control used_amount-field is-fullwidth">
                    <input class="input" type="text" v-model="used_amount" v-on:change="depositPayment()">
                </p>
            </div>
        </td>
        <td>
            <div class="field select is-fullwidth select-deposit">
                <div class="control">
                    <select v-model="deposit" v-on:change="depositPayment()">
                        <option selected :value="null" disabled>Deposit</option>
                        <option value="100%">Pay in full</option>
                        <option value="50%-50%">50%</option>
                        <option value="30%-70%">30%</option>
                    </select>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>

    export default {
        props: ['invoice', 'transactionTotals'],
        components: {

        },
        data() {
            return {
                deposit : '',
                used_amount: ''
                //deposit: this.invoice.deposit_payment
            }
        },
        methods: {
            depositPayment(){
                let balance = Number(this.invoice.balance_due);
                let paid_amount = Number(this.invoice.paid_amount);
                if (this.deposit == '100%') {
                    this.used_amount = balance - paid_amount
                } else if (this.deposit == '50%-50%') {
                    this.used_amount = (balance - paid_amount) * 50 / 100
                } else if (this.deposit == '30%-70%') {
                    this.used_amount = (balance - paid_amount) * 30 / 100
                }
                this.$store.commit('setMultiInvoiceAmountUsed', {'id': this.invoice.id, 'amount_used': this.used_amount, 'deposit': this.deposit})

                //this.$store.dispatch('paymentDepositInvoice', {transaction_id: this.$route.params.id, multi_invoice_id: this.invoice.id, deposit: this.deposit, paid_amount: this.invoice.paid_amount})
            }
        },
        computed: {
            deposit: {
                get(){
                    return this.invoice.deposit_payment;
                },
                set(value){
                    this.invoice.deposit_payment = value;
                }
            },
            getCurrency: function () {
                return this.transactionTotals.currency == 2 ? '$' : '¥'
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 12px;
    }
    .picture-td {
        width: 65px;
    }
    .link {
        cursor: pointer;
    }
    .image {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Banking/UnpaidMultiInvoiceTableRow.vue